import { Button } from "@/components/ui/button";
import { Minimize2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/useResponsive";

interface PlayerExpandedHeaderProps {
  onToggleExpand: () => void;
}

export function PlayerExpandedHeader({
  onToggleExpand,
}: PlayerExpandedHeaderProps) {
  const isMobile = useIsMobile();

  return (
    <div className="flex items-center justify-between mb-4 flex-shrink-0 font-archivo">
      <h2
        className={cn(
          "font-semibold text-white",
          isMobile ? "text-lg" : "text-lg md:text-xl",
        )}
      >
        Now Playing
      </h2>
      <Button
        variant="ghost"
        size="sm"
        onClick={onToggleExpand}
        className="text-[#9A96C4] hover:text-white hover:bg-white/10"
      >
        <Minimize2 className="h-4 w-4 mr-2" />
        <span className="hidden sm:inline">Minimize</span>
      </Button>
    </div>
  );
}
